import React, { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import { motion } from 'framer-motion';
import * as Icons from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { Divider, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Modules = ({
  businessModules,
  isTablet,
  main,
  activeModule,
  isDarkMode,
  businessPreference,
  handleEditModule,
  currentSectionState,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { segmentId } = useParams();
  const location = useLocation();
  const pageLoaded = useSelector((state) => state.core.pageLoaded);
  const activeSegment = activeModule?.segments?.find((s) => s.id === segmentId);
  const currentUser = useSelector((state) => state.core.user);
  const [currentHoveredModule, setCurrentHoveredModule] = useState();
  const currentPlatform = useSelector(state => state.core.currentPlatform);

  const RestrictedModule = ({ children }) => {
    if (
      currentSectionState === 'SETTINGS' ||
      currentSectionState === 'TOOLS' ||
      currentSectionState === 'MYNODE' ||
      currentSectionState === 'NODE'
    ) {
      return null;
    }
    return children;
  };

  const handleClickSegment = (finalSettingsUrl, segment) => {
    const url = finalSettingsUrl + '/' + segment.id;
    navigate(url);
  };

  const currentUserPerm = currentUser?.activeBusiness?.role;

  const sectionResolver = () => {
    if (currentSectionState === 'OPERATIONS' || currentSectionState === 'FINANCES') {
      return '/bos';
    } else if (currentSectionState === 'PULSE') {
      return '/pulse';
    } else if (currentSectionState === 'AI') {
      return '/ai';
    } else if (currentSectionState === 'SETTINGS') {
      return '/app';
    }

  }



  const filtredModules =
    businessModules?.length > 0 &&
    businessModules?.filter((module) => {
      if (
        (currentUserPerm === 'EMPLOYEE' || currentUserPerm === 'VIEWER') &&
        (
          module?.url.startsWith('/mynode') ||
          module?.url.startsWith('/settings'))
      ) {
        return false;
      }
      return true;
    });

  return (
    <>
      {filtredModules?.length > 0 &&
        filtredModules?.map((module, index) => {
          const IconComponent = Icons[module.icon] || Icons.Error;
          const finalSettingsUrl = main
            ? sectionResolver() + (module?.url || '/links/' + index)
            : module?.url || '/links/' + index;

          // Animation settings
          const animationProps = {
            initial:
              pageLoaded == true
                ? { opacity: 1, y: 0 }
                : { opacity: 0, x: -20 },
            animate:
              pageLoaded == true ? { opacity: 1, y: 0 } : { opacity: 1, x: 0 },
            transition:
              pageLoaded == true ? {} : { delay: index * 0.2, duration: 0.5 },
          };

          return (
            <motion.div
              key={module.id + index + 'module' + module?.link}
              style={{
                paddingTop: '0.05rem',
                paddingBottom: '0.05rem',
              }}
              {...animationProps}
            >
              <div
                onMouseEnter={() => setCurrentHoveredModule(module?.id)}
                onMouseLeave={() => setCurrentHoveredModule(null)}
                style={{
                  borderRadius: handleEditModule ? '10px 0px 0px 10px' : '3px',
                  backgroundColor:
                    activeModule?.id === module?.id ||
                      '/bos' + module?.url === location?.pathname
                      ? businessPreference?.mainColor + '15'
                      : 'transparent',
                  transition: 'background-color 0.3s, color 0.3s',
                  marginTop: '-1.5px',
                }}
                className="module-container"
              >
                <div
                  style={{
                    padding: '6px',
                  }}
                  className={` ${isTablet ? 'd-flex align-c' : 'd-flex'
                    } hover align-c`}
                >
                  <div
                    onClick={() => navigate(finalSettingsUrl)}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start',
                      height: '100%',
                    }}
                  >
                    <Tooltip title={t(module?.name)}>
                      {module?.icon?.startsWith('https') ? (
                        <img
                          src={module?.icon}
                          alt={module?.name}
                          style={{
                            width: isTablet ? '23px' : '18px',
                            height: isTablet ? '23px' : '18px',
                            marginRight: isTablet ? '1px' : '3px',
                            marginTop: isTablet ? '' : '2.5px',
                            objectFit: 'contain',
                          }}
                        />
                      ) : (
                        <IconComponent
                          htmlColor={isDarkMode ? '#FFF' : '#000'}
                          sx={{
                            paddingRight: isTablet ? '1px' : '3px',
                            fontSize: isTablet ? '23px' : '18px',
                            marginTop: isTablet ? '' : '2px',
                            fontWeight:
                              currentHoveredModule === module?.id ? 700 : 500,
                          }}
                        />
                      )}
                    </Tooltip>
                  </div>
                  {!isTablet && (
                    <div
                      style={{ marginTop: '2px' }}
                      className="row d-flex parent-element justify-content-between px-3"
                    >
                      <div className="col-10 align-left ">
                        <Typography
                          onClick={() => navigate(finalSettingsUrl)}
                          fontWeight={
                            activeModule?.id === module?.id ||
                              '/bos' + module?.url === location?.pathname
                              ? 600
                              : currentHoveredModule === module?.id
                                ? 700
                                : 500
                          }
                          fontSize="12px"
                          color={isDarkMode ? '#FFF' : '#000'}
                          variant="body2"
                        >
                          {module?.url?.startsWith('/chekup') && currentPlatform === 'CHEKUP' ? t(module?.name) : (module?.name)}
                        </Typography>
                        {!isTablet && handleEditModule && (
                          <>
                            {module?.segments &&
                              module?.segments?.length > 0 && (
                                <div>
                                  {module?.segments?.map((segment, index) => (
                                    <div
                                      key={index + 'segment'}
                                      className="align-left"
                                      onClick={() =>
                                        handleClickSegment(
                                          finalSettingsUrl,
                                          segment
                                        )
                                      }
                                    >
                                      <div className="d-flex middle-content">
                                        {activeSegment?.id === segment?.id && (
                                          <Icons.FilterListOutlined
                                            fontSize="10px"
                                            sx={{
                                              marginRight: '5px',
                                              marginLeft: '-20px',
                                              marginTop: '-1px',
                                            }}
                                          />
                                        )}
                                        <Typography
                                          fontWeight={
                                            activeSegment?.id === segment?.id
                                              ? 500
                                              : 400
                                          }
                                          fontSize="10px"
                                          className="hover"
                                          sx={{
                                            '&:hover': {
                                              fontWeight: 500,
                                            },
                                          }}
                                          color={
                                            isDarkMode
                                              ? '#FFFFFF95'
                                              : '#00000095'
                                          }
                                          variant="body2"
                                        >
                                          {segment?.name}
                                        </Typography>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                          </>
                        )}
                      </div>

                      <RestrictedModule>
                        {(currentSectionState === 'OPERATIONS' ||
                          currentSectionState === 'FINANCES' ||
                          currentSectionState === 'MARKETING') && handleEditModule && (
                            <div
                              onClick={() => handleEditModule(module)}
                              className="col-2 align-right settings-icon-container"
                            >
                              <Icons.TuneOutlined
                                fontSize="10px"
                                htmlColor={'transparent'}
                                sx={{
                                  marginTop: '3px',
                                  '&:hover': {
                                    color: isDarkMode
                                      ? '#FFF'
                                      : `${businessPreference?.mainColor}`,
                                  },
                                }}
                              />
                            </div>
                          )}
                      </RestrictedModule>
                    </div>
                  )}
                </div>
              </div>
              {index !== filtredModules?.length - 1 && (
                <Divider
                  component="div"
                  sx={{
                    borderColor: businessPreference?.mainColor + '10',
                    width: '120%',
                    marginLeft: '-20px',
                  }}
                />
              )}
            </motion.div>
          );
        })}
      <style>
        {`
        .module-container:hover {
          background-color: ${businessPreference?.mainColor + '15'} !important;
        }

        .module-container:hover .MuiSvgIcon-root,
        .module-container:hover .MuiTypography-root {
          color: ${isDarkMode ? '#FFF' : `${businessPreference?.mainColor}`
          } !important;
        }
      `}
      </style>
    </>
  );
};

export default Modules;
